import { rawCounties } from './counties.tsv';

const countiesList = rawCounties
  .trim()
  .split('\n')
  .map((line) => {
    const segments = line.split('\t');
    if (segments.length !== 2) {
      throw new Error(`Invalid line in counties.tsv: ${line}`);
    }

    const [name, stateCode] = segments;
    return { name, stateCode };
  });

const counties = {};

for (const { name, stateCode } of countiesList) {
  if (!counties[stateCode]) {
    counties[stateCode] = [];
  }
  counties[stateCode].push(name);
}

// CT is weird
counties.CT = [
  'Fairfield',
  'Hartford',
  'Litchfield',
  'Middlesex',
  'New Haven',
  'New London',
  'Tolland',
  'Windham',
];

export { counties };
